import { format } from 'date-fns';

const DATE_FNS_FORMAT = 'h:mmaaa';

/**
 * Formats a message timestamp in milliseconds to a readable time string
 * @param messageDateMs - The message date in milliseconds
 * @returns Formatted time string (e.g., "2:30 pm")
 */
export default function getMessageTimestampText(messageDateMs: string): string {
  if (!messageDateMs) return '';
  return format(new Date(+messageDateMs), DATE_FNS_FORMAT);
}
